import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as transactionApi from '../../api/transaction';
import { message } from 'antd';

// 获取交易记录列表
export const fetchTransactionRecords = createAsyncThunk(
  'transaction/fetchTransactionRecords',
  async (params, { rejectWithValue }) => {
    try {
      const response = await transactionApi.getTransactionRecordList(params);
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取交易记录列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取交易记录列表失败');
    }
  }
);

// 初始状态
const initialState = {
  transactionRecordList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    error: null,
    searchParams: {
      userId: undefined,
      transactionNo: '',
      transactionType: undefined,
      transactionStatus: undefined,
      minAmount: undefined,
      maxAmount: undefined,
      businessType: '',
      businessId: '',
      orderNo: '',
      username: '',
      nickname: '',
      startTime: undefined,
      endTime: undefined
    }
  }
};

// 创建slice
const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.transactionRecordList.searchParams = {
        ...state.transactionRecordList.searchParams,
        ...action.payload
      };
    },
    resetSearchParams: (state) => {
      state.transactionRecordList.searchParams = {
        userId: undefined,
        transactionNo: '',
        transactionType: undefined,
        transactionStatus: undefined,
        minAmount: undefined,
        maxAmount: undefined,
        businessType: '',
        businessId: '',
        orderNo: '',
        username: '',
        nickname: '',
        startTime: undefined,
        endTime: undefined
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理获取交易记录列表
      .addCase(fetchTransactionRecords.pending, (state) => {
        state.transactionRecordList.loading = true;
        state.transactionRecordList.error = null;
      })
      .addCase(fetchTransactionRecords.fulfilled, (state, action) => {
        state.transactionRecordList.loading = false;
        state.transactionRecordList.data = action.payload.data.records || [];
        state.transactionRecordList.total = action.payload.data.total || 0;
        
        // 使用传入的page和size参数更新状态，而不是依赖后端返回的值
        if (action.payload.params) {
          if (action.payload.params.page) {
            state.transactionRecordList.current = action.payload.params.page;
          } else {
            state.transactionRecordList.current = action.payload.data.current || 1;
          }
          
          if (action.payload.params.size) {
            state.transactionRecordList.size = action.payload.params.size;
          } else {
            state.transactionRecordList.size = action.payload.data.size || 10;
          }
        } else {
          state.transactionRecordList.current = action.payload.data.current || 1;
          state.transactionRecordList.size = action.payload.data.size || 10;
        }
        
        // 检查是否有明确传入的搜索参数，如果有则更新searchParams
        if (action.payload.params) {
          // 过滤掉page和size参数，避免将它们保存到searchParams中
          const { page, size, ...searchParams } = action.payload.params;
          
          // 如果没有传入特定的搜索参数，则不要覆盖现有的searchParams
          const hasSearchParams = Object.values(searchParams).some(value => 
            value !== undefined && value !== '' && value !== null
          );
          
          // 只有在有明确的搜索参数时才更新
          if (hasSearchParams) {
            state.transactionRecordList.searchParams = {
              ...state.transactionRecordList.searchParams,
              ...searchParams
            };
          }
        }
      })
      .addCase(fetchTransactionRecords.rejected, (state, action) => {
        state.transactionRecordList.loading = false;
        state.transactionRecordList.error = action.payload;
      });
  }
});

export const { setSearchParams, resetSearchParams } = transactionSlice.actions;

export default transactionSlice.reducer; 